import { Stack, useTheme } from '@lingoda/ui';
import { CalendarDotsIcon } from '@lingoda/ui/icons/lingodaIcons';
import { LeadTimeExplanationMessage } from './LeadTimeExplanationMessage';
import type { LeadTime } from './resolveLeadTime';

export const LeadTimeExplanationBanner = (leadTime: LeadTime) => {
    const theme = useTheme();

    return (
        <Stack
            direction="row"
            spacing={2.5}
            sx={{
                alignItems: 'center',
                px: 2,
                py: 1.5,
                borderRadius: `${theme.shape.borderRadius}px`,
                backgroundColor: theme.palette.background.default,
            }}
        >
            <CalendarDotsIcon size={24} color={theme.colors.text.accent} aria-hidden />
            <LeadTimeExplanationMessage {...leadTime} htmlColor="text.primary" />
        </Stack>
    );
};
